'use client';

import React from 'react';
import styles from './BlogDivComp.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { useAOS } from '../../../../lib/hooks/useAOS';
import StyledButton from '@/src/components/StyledButton/StyledButton';

type BlogDivCompProps = {
  title: string;
  subtitle: string;
  description: string;
  cta: string;
  link: string;
  largeImage: string;
  smallImage: string;
};

const BlogDivComp = ({
  title,
  subtitle,
  description,
  cta,
  link,
  largeImage,
  smallImage,
}: BlogDivCompProps) => {
  useAOS();

  return (
    <section className={styles.blogDiv} aria-labelledby="blog-title">
      <div className={styles.blogTextContent} data-aos="fade-up">
        <span className={styles.blogSubtitle}>{subtitle}</span>
        <h2 className={styles.blogTitle} id="blog-title">{title}</h2>
        <p className={styles.blogDescription}>{description}</p>
        <StyledButton href={link}>{cta}</StyledButton>
      </div>

      <div className={styles.blogImageContainer} data-aos="zoom-in">
        <div className={styles.imageWrapper}>
          <Image
            src={largeImage}
            alt="Travel story landscape"
            width={450}
            height={300}
            className={styles.blogMainImage}
            loading="lazy"
          />
          <Image
            src={smallImage}
            alt="Traveler enjoying destination"
            width={160}
            height={160}
            className={styles.blogOverlayImage}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default BlogDivComp;
